const Data = {
  FETCH_DATA: "FETCH_DATA",
  REMOVE_DATA: "REMOVE_DATA",
  SET_HEADER_TITLE: "SET_HEADER_TITLE",
  SAVE_DATA: "SAVE_DATA",
}

const Component = {
  FULL_PAGE_LOADER: "FULL_PAGE_LOADER",
  SHOW_TOAST: "SHOW_TOAST",
  HIDE_TOAST: "HIDE_TOAST",
  TOGGLE_DRAWER: "TOGGLE_DRAWER",
  SHOW_POPUP: "SHOW_POPUP",
  HIDE_POPUP: "HIDE_POPUP",
}

const Theme = {
  SET_THEME: "SET_THEME",
}

module.exports = {
  ...Data,
  ...Component,
  ...Theme,
}



// WEBPACK FOOTER //
// ./src/store/action/types.js